/**
 * Calculate estimated total stake
 * @param {Number} stake - stake for race
 * @param {Object} config - configuration object
 * @param {Boolean} [config.isEachWay] - flag that shows whether eachWay bet present or not
 */
export function calculateStake(stake, config = {}) {
    if (Number.isNaN(stake)) {
        return 0;
    }
    const {
        isEachWay,
        numberLines,
    } = config

    let totalStake = isEachWay ? 2 * stake : stake;
    if (numberLines) {
        totalStake *= numberLines
    }

    return totalStake
}

export function calculateSingleStake(bet) {
    if (!bet.stake) {
        return 0
    }

    const parsedStake = parseFloat(bet.stake)
    const calculatedStake = calculateStake(
        parsedStake,
        {
            isEachWay: bet.isEachWay,
        },
    )

    return calculatedStake
}

export function calculateMultipleStake(multiple) {
    if (!multiple.stakeValue) {
        return 0
    }

    const parsedStake = parseFloat(multiple.stakeValue)
    const calculatedStake = calculateStake(
        parsedStake,
        {
            isEachWay: multiple.isEachWay,
            numberLines: multiple.numberLines,
        },
    )

    return calculatedStake
}

export function calculateTotalStake(selectedBets, multiples) {
    const singlesTotal = selectedBets
        .reduce((runningTotal, bet) => (
            runningTotal + calculateSingleStake(bet)
        ), 0)

    const multiplesTotal = (multiples.length === 0)
        ? 0
        : multiples
            .reduce((runningTotal, multiple) => (
                runningTotal + calculateMultipleStake(multiple)
            ), 0)

    return (singlesTotal + multiplesTotal).toFixed(2)
}

/**
 * Calculates a breakdown of free money / user money.
 *
 * @param  {Number} stake e.g. 5
 * @param  {Object} bet - typical selection that you'd see in selectedBets
 * @param  {[type]} freeBetAmount e.g. 2
 *
 * @return {Object} e.g. { userStake: 3, freeStake 2 }
 */
export function calculateMoneyBreakdown(stake, bet, freeBetAmount) {
    // Double the base stake when EW
    const totalStake = (bet.isEachWay)
        ? stake * 2
        : stake

    // Calculate the split
    const freeStake = freeBetAmount >= totalStake
        ? totalStake
        : freeBetAmount
    const userStake = freeStake >= totalStake
        ? 0
        : totalStake - freeStake

    return {
        userStake,
        freeStake,
    }
}

export function isEmptyStake(stake) {
    return (stake === '' || parseFloat(stake) === 0)
}



// WEBPACK FOOTER //
// /src/js/common/utils/calculateStake.js